import { observer } from "mobx-react";
import * as React from "react";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "@egds/react-core/layout-flex";
import { useLocalization } from "@shared-ui/localization-context";
import { locKeys } from "components/flexComponents/Flights/components/l10";
import { UitkPagingNextButton, UitkPagingPrevButton } from "@egds/react-core/button";

export interface PaginationButtonProps {
  numOfPages: number;
  preButtonDisabled: boolean;
  nextButtonDisabled: boolean;
  onPrevCallback: () => void;
  onNextCallback: () => void;
}

export const PaginationButton = observer((props: PaginationButtonProps) => {
  const { formatText } = useLocalization();
  const isSinglePageChart = props.numOfPages <= 1;

  if (isSinglePageChart) {
    return null;
  }

  return (
    <UitkLayoutFlex justifyContent="space-between">
      <UitkLayoutFlexItem>
        <UitkPagingPrevButton
          iconId="prev-button"
          onClick={props.onPrevCallback}
          disabled={props.preButtonDisabled}
          aria-label={formatText(locKeys.flightBarChartButtonPrev)}
        />
      </UitkLayoutFlexItem>
      <UitkLayoutFlexItem>
        <UitkPagingNextButton
          iconId="next-button"
          onClick={props.onNextCallback}
          disabled={props.nextButtonDisabled}
          aria-label={formatText(locKeys.flightBarChartButtonNext)}
        />
      </UitkLayoutFlexItem>
    </UitkLayoutFlex>
  );
});
